<template>
    <side-container
        v-if="isShow"
        :width="500"
        :headerTitle="'积分设置'"
        @close="isShow = false"
        :isShowFooterBtn="false">
        <!-- body -->
        <div class="body pl-12 pr-12 pt-20">
            <div class="row align-items-center color-333 fs-14">
                <span class="title mr-12">积分规则:</span>
                <span class="mr-8">消费1元=</span>
                <el-input placeholder="请输入整数" @input="limit1(form, 'redemption_ratio')" class="input1" v-model="form.redemption_ratio">
                    <span class="color-333 fs-14" slot="suffix">积分</span>
                </el-input>
            </div>
            <div class="column mt-20">
                <span class="title mr-12">积分限制:</span>
                <el-checkbox-group v-model="form.restrictions_list">
                <div class="column limit-group mt-12 p-12">
                    <div class="row mb-20">
                        <div class="expaned">
                            <el-checkbox class="all" :label="0">改价商品不参与积分</el-checkbox>
                        </div>
                        <div class="expaned">
                            <el-checkbox class="all" :label="1">整单打折的订单不参与积分</el-checkbox>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="expaned">
                            <el-checkbox class="all" :label="2">会员日折扣订单不参与积分</el-checkbox>
                        </div>
                        <!-- <div class="expaned">
                            <el-checkbox class="all" :label="6">减免订单不参与积分</el-checkbox>
                        </div> -->
                        <div class="expaned">
                            <el-checkbox class="all" :label="3">会员价商品不参与积分</el-checkbox>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="expaned">
                            <el-checkbox class="all" :label="4">余额支付金额不参与积分</el-checkbox>
                        </div>
                        <div class="expaned">
                            <el-checkbox class="all" :label="5">抹零订单不参与积分</el-checkbox>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="expaned">
                            <el-checkbox class="all" :label="6">减免订单不参与积分</el-checkbox>
                        </div>
                    </div>
                </div>
                </el-checkbox-group>
            </div>
        </div>
        <!--  footer  -->
        <div
            class="footer fx-h-end"
            slot="footer">
            <el-button
                :disabled="!isCanSubmit"
                @click="submit"
                size="medium"
                type="primary"
            >确认</el-button>
        </div>
    </side-container>
</template>

<script lang="ts">
import Vue from 'vue'
import SideContainer from "@/components/layout/side-container-style2.vue"
import $fetch from '@/api/index'
import { createComponent, ref, computed } from '@vue/composition-api'
import { openMessage } from '../../../../utils/system'
import { inputLimit } from '@/utils'

export default createComponent({
    setup() {
        const isShow = ref(false)
        const form = ref<{
            id?: number,
            redemption_ratio: number,
            restrictions_list: number[]
        }>({
            redemption_ratio: "",
            restrictions_list: []
        })

        const isCanSubmit = computed(() => {
            return form.value.redemption_ratio.toString().length > 0
        })

        let isNotCreated = true
        const limit1 = inputLimit(/^[0-9]{1}([0-9]{0,4})?$/)

        function open() {
            isShow.value = true
            getPointRule()
        }

        function getPointRule() {
            $fetch.post({
                url: '/activity/getpointrules',
                params: {}
            }).then(data => {
                form.value = data.member_points_rules
                isNotCreated = false
            }).catch(e => {
                if (e.code === "POINTS_RULES_NOT_CREATE") {
                    isNotCreated = true
                } else {
                    openMessage("error", e.message || '获取积分设置失败')
                }
            })
        }

        function submit() {
            if (isNotCreated) {
                $fetch.post({
                    url: '/activity/createpointsrules',
                    params: {
                        redemption_ratio: form.value.redemption_ratio,
                        rules_list: form.value.restrictions_list
                    }
                }).then(data => {
                    isShow.value = false
                    openMessage("success", '创建积分设置成功')
                }).catch(e => {
                    openMessage("error", e.message)
                })
            } else {
                $fetch.post({
                    url: '/activity/updatepointsrules',
                    params: {
                        points_rules_id: form.value.id,
                        rules_list: form.value.restrictions_list,
                        redemption_ratio: form.value.redemption_ratio
                    }
                }).then(data => {
                    isShow.value = false
                    openMessage("success", '设置成功')
                }).catch(e => {
                    openMessage("error", e.message)
                })
            }
        }

        return {
            form,
            isShow,
            limit1,
            open,
            submit,
            isCanSubmit
        }
    },
    components: {
        SideContainer
    }
})
</script>

<style lang="scss" scoped>
.input1 {
    width: 194px;
}

.limit-group {
    height: 168px;
    background: #F2F2F2;
}

.footer {
    display: flex;
    width: 100%;
    padding-right: 12px;
}
</style>